// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION: Record<string, any> = {
    "dirty": false,
    "raw": "cbfc0de",
    "hash": "cbfc0de",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "cbfc0de",
    "semverString": null,
    "version": "1.0.0",
    "buildNumber": "20250430021320"
};
/* tslint:enable */
